import { useQuery, useMutation } from "react-query";
import { getQuestion } from "../store/services/service";

export const useGetQuestion = () => {
  return useMutation(getQuestion);
};
